function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import KZUIComponent from '../base';
import Button from '../Button';
import Dialog from '../Dialog';

var Modal = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Modal, _KZUIComponent);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);
    _this.state = {
      hide: props.hide
    };

    _this.autoBind('handleClick', 'handleCancel', 'handleConfirm');

    return _this;
  }

  _createClass(Modal, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      return _objectSpread({}, this.state, {
        hide: props.hide
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        hide: true
      });
      this.props.onCancel();
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      this.setState({
        hide: true
      });
      this.props.onConfirm();
    }
  }, {
    key: "render",
    value: function render() {
      var hide = this.state.hide;
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          children = _this$props.children,
          title = _this$props.title,
          cancelText = _this$props.cancelText,
          confirmText = _this$props.confirmText,
          disableHide = _this$props.disableHide;
      var actions = [/*#__PURE__*/React.createElement(Button, {
        key: "cancel",
        onClick: this.handleCancel,
        style: {
          marginRight: 10
        }
      }, cancelText), /*#__PURE__*/React.createElement(Button, {
        key: "confirm",
        onClick: this.handleConfirm,
        type: "primary",
        status: "normal"
      }, confirmText)];

      var finalStyle = _objectSpread({
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: 0
      }, style);

      var finalHide = disableHide ? false : hide;
      return /*#__PURE__*/React.createElement(Dialog, {
        title: title,
        hide: finalHide,
        actions: actions,
        style: finalStyle,
        className: className,
        onClose: this.handleCancel,
        hasClose: true
      }, children);
    }
  }]);

  return Modal;
}(KZUIComponent);

Modal.defaultProps = {
  className: '',
  style: {},
  hide: true,
  title: '操作对话框',
  onConfirm: function onConfirm() {},
  onCancel: function onCancel() {},
  confirmText: '确定',
  cancelText: '取消',
  disableHide: false
};
Modal.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  hide: PropTypes.bool,
  title: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  disableHide: PropTypes.bool
};
export default Modal;